import { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import useUser from './context/useUser';

const LEGACY_POSTHOG_PROPERTIES_TO_UNSET = [
  'email',
  'name',
  'firstName',
  'lastName',
  'company',
] as const;

const getCleanupFlagKey = (userId: string) =>
  `posthog_legacy_cleanup_done:${userId}`;

const PosthogIdentitySync = () => {
  const posthog = usePostHog();
  const { user } = useUser();

  useEffect(() => {
    if (!posthog || !user) {
      return;
    }

    posthog.register({
      role: user.role,
    });
  }, [posthog, user]);

  useEffect(() => {
    if (!posthog || !user?._id) {
      return;
    }

    const userId = String(user._id);
    const cleanupFlagKey = getCleanupFlagKey(userId);
    if (localStorage.getItem(cleanupFlagKey) === 'true') {
      return;
    }

    const hasLegacyProperties = LEGACY_POSTHOG_PROPERTIES_TO_UNSET.some(
      (property) => posthog.get_property(property) !== undefined,
    );
    if (!hasLegacyProperties) {
      localStorage.setItem(cleanupFlagKey, 'true');
      return;
    }

    posthog.capture('$set', {
      $unset: [...LEGACY_POSTHOG_PROPERTIES_TO_UNSET],
    });
    (posthog as any)?.persistence?.unregister?.('$stored_person_properties');
    localStorage.setItem(cleanupFlagKey, 'true');
  }, [posthog, user]);

  return null;
};

export default PosthogIdentitySync;
